import React from 'react';
import PropTypes from 'prop-types';

function DetailsContentBody({ children }) {
    return (<section style={{ position: 'relative' }} className="content-body">
        {children}
    </section>)
}

DetailsContentBody.propTypes = {
    children: PropTypes.any.isRequired,
};

export default DetailsContentBody;
